import {Title, Tooltip} from "@mantine/core";
import {useTranslation} from "react-i18next";
import {useSearchParams} from "react-router-dom";
import type {PortalWidgetLink} from "./types";
import {usePortalData} from "./usePortalData";
import IconChevronRight from "../../assets/chevron-right.svg?react";
import {ExperimentalLink} from "../../components/ExperimentalLink";
import classes from "./PortalsPage.module.css";

export function PortalsPage() {
    const [searchParams] = useSearchParams();
    const selectedGroupingName = searchParams.get("filter");
    const {t} = useTranslation();
    const {relevantWidgets, relevantGroupings} = usePortalData();

    const selectedGrouping = relevantGroupings.find(
        (g) => g.name === selectedGroupingName
    );
    const groupingProductIds = selectedGrouping?.products_json
        ? new Set(JSON.parse(selectedGrouping.products_json) as string[])
        : null;

    const displayedWidgets = (
        groupingProductIds
            ? relevantWidgets.filter((w) => {
                  if (!w.conditions || w.conditions.length === 0) return true;
                  return w.conditions.some((group) =>
                      group.some((id) => groupingProductIds.has(String(id)))
                  );
              })
            : relevantWidgets
    ).slice(0, 4);

    return (
        <>
            <Title mb="md" size={"lg"} className={classes.title}>
                {t("Widget.internal.portal.title")}
            </Title>
            {displayedWidgets.map((widget) => (
                <div key={widget.id} className={classes.widgetCard}>
                    {widget.title && (
                        <Tooltip
                            label={widget.description}
                            disabled={!widget.description}
                        >
                            <div className={classes.widgetTitle}>
                                {widget.title}
                                <span className={classes.widgetTitleChevron}>
                                    ›
                                </span>
                            </div>
                        </Tooltip>
                    )}
                    {widget.links.length > 0 && (
                        <div className={classes.linksGroup}>
                            {widget.links
                                .filter(
                                    (link: PortalWidgetLink) => link.targetUrl
                                )
                                .map((link: PortalWidgetLink) => (
                                    <ExperimentalLink
                                        key={link.targetUrl}
                                        href={
                                            link.targetUrl
                                                ? new URL(link.targetUrl)
                                                      .pathname
                                                : "#"
                                        }
                                        className={classes.linkChip}
                                    >
                                        {link.title}
                                        <span
                                            className={classes.linkChipChevron}
                                        >
                                            <IconChevronRight />{" "}
                                        </span>
                                    </ExperimentalLink>
                                ))}
                        </div>
                    )}
                </div>
            ))}
        </>
    );
}
